export default "__VITE_ASSET__DeTG$7Yu__"